<ion-fab-button *ngIf="!withText" class="button-bookmark" [ngClass]="{ active: item?.isBookmarked }" (click)="toggle()">
  <ion-icon name="bookmark"></ion-icon>
</ion-fab-button>
<ion-button *ngIf="withText" [ngClass]="{ active: item?.isBookmarked }" (click)="toggle()">
  <ion-icon name="bookmark" slot="start"></ion-icon> Save
</ion-button>
